import React from 'react';
import { IconCategoryValue as IconCategoryValueUDL } from './component';
import { IconCategoryValue as IconCategoryValueLegacy } from './component.legacy';
import { IconCategoryValueProps } from './types';

export const IconCategoryValue = <C,>(props: IconCategoryValueProps<C>) => {
  const { renderAsLegacy = false } = props;

  if (renderAsLegacy || (props.chakra && props.chakra === 'off')) {
    return <IconCategoryValueLegacy {...props} />;
  }
  return <IconCategoryValueUDL {...props} />;
};
